// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1PAxb","loaderOuter":"PageOverlayLoader_loaderOuter__29Yhb"};